import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { allEnumValues } from "./helper.js";
import "./customer_identifier.js";
import { FulfillmentMethod } from "./fulfillment_method.js";
import { OrderChannel } from "./order_channel.js";
import { isKiosk as isKiosk$1, name as name$1 } from "./order_channel_helper.js";
//#region src/fulfillment_method_helper.ts
var fulfillment_method_helper_exports = /* @__PURE__ */ __exportAll({
	customerIdentifiers: () => customerIdentifiers,
	enumFromString: () => enumFromString,
	getCurbside: () => getCurbside,
	getDelivery: () => getDelivery,
	getDineIn: () => getDineIn,
	getOutpost: () => getOutpost,
	getOutpostFulfillmentMethods: () => getOutpostFulfillmentMethods,
	getToGo: () => getToGo,
	isAnOutpost: () => isAnOutpost,
	isCurbside: () => isCurbside,
	isDelivery: () => isDelivery,
	isDineIn: () => isDineIn,
	isKiosk: () => isKiosk,
	isToGo: () => isToGo,
	name: () => name,
	nameWithChannel: () => nameWithChannel,
	orderChannel: () => orderChannel,
	stringFromEnum: () => stringFromEnum
});
function name(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 50:
		case 1:
		case 40: return "To Go";
		case 2:
		case 41: return "Dine In";
		case 7: return "Outpost Pickup";
		case 30:
		case 3:
		case 20: return "Pickup";
		case 31:
		case 4:
		case 21: return "Dine In";
		case 32:
		case 5:
		case 42:
		case 22: return "Curbside";
		case 33:
		case 6:
		case 23: return "Outpost Pickup";
		case 34:
		case 8:
		case 24: return "Delivery";
	}
}
function getFulfillmentMethodOfOrderChannel(channel, isFulfillmentMethodOfCategory) {
	return allEnumValues(FulfillmentMethod).find((fulfillmentMethod) => {
		return orderChannel(fulfillmentMethod) === channel && isFulfillmentMethodOfCategory(fulfillmentMethod);
	}) ?? null;
}
function getToGo(orderChannel) {
	return getFulfillmentMethodOfOrderChannel(orderChannel, isToGo);
}
function getDineIn(orderChannel) {
	return getFulfillmentMethodOfOrderChannel(orderChannel, isDineIn);
}
function getCurbside(orderChannel) {
	return getFulfillmentMethodOfOrderChannel(orderChannel, isCurbside);
}
function getOutpost(orderChannel) {
	return getFulfillmentMethodOfOrderChannel(orderChannel, isAnOutpost);
}
function getDelivery(orderChannel) {
	return getFulfillmentMethodOfOrderChannel(orderChannel, isDelivery);
}
function nameWithChannel(fulfillmentMethod) {
	return `${name(fulfillmentMethod)} (${name$1(orderChannel(fulfillmentMethod))})`;
}
function orderChannel(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 50: return "drive-thru";
		case 2:
		case 7:
		case 1: return "kiosk";
		case 42:
		case 41:
		case 40: return "linebuster";
		case 5:
		case 8:
		case 4:
		case 6:
		case 3: return "flash";
		case 22:
		case 24:
		case 21:
		case 23:
		case 20: return "web";
		case 32:
		case 34:
		case 31:
		case 33:
		case 30: return "catering";
	}
}
function isKiosk(fulfillmentMethod) {
	return isKiosk$1(orderChannel(fulfillmentMethod));
}
function isToGo(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 30:
		case 50:
		case 3:
		case 1:
		case 40:
		case 20: return true;
		case 32:
		case 34:
		case 31:
		case 33:
		case 5:
		case 8:
		case 4:
		case 6:
		case 2:
		case 7:
		case 42:
		case 41:
		case 22:
		case 24:
		case 21:
		case 23: return false;
	}
}
function isDineIn(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 31:
		case 4:
		case 2:
		case 41:
		case 21: return true;
		case 32:
		case 34:
		case 33:
		case 30:
		case 50:
		case 5:
		case 8:
		case 6:
		case 3:
		case 7:
		case 1:
		case 42:
		case 40:
		case 22:
		case 24:
		case 23:
		case 20: return false;
	}
}
function isAnOutpost(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 33:
		case 6:
		case 7:
		case 23: return true;
		case 32:
		case 34:
		case 31:
		case 30:
		case 50:
		case 5:
		case 8:
		case 4:
		case 3:
		case 2:
		case 1:
		case 42:
		case 41:
		case 40:
		case 22:
		case 24:
		case 21:
		case 20: return false;
	}
}
function isCurbside(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 32:
		case 5:
		case 42:
		case 22: return true;
		case 34:
		case 31:
		case 33:
		case 30:
		case 50:
		case 8:
		case 4:
		case 6:
		case 3:
		case 2:
		case 7:
		case 1:
		case 41:
		case 40:
		case 24:
		case 21:
		case 23:
		case 20: return false;
	}
}
function isDelivery(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 34:
		case 8:
		case 24: return true;
		case 32:
		case 31:
		case 33:
		case 30:
		case 50:
		case 5:
		case 4:
		case 6:
		case 3:
		case 2:
		case 7:
		case 1:
		case 42:
		case 41:
		case 40:
		case 22:
		case 21:
		case 23:
		case 20: return false;
	}
}
function customerIdentifiers(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 31:
		case 50:
		case 4:
		case 3:
		case 2:
		case 1:
		case 41:
		case 40:
		case 21:
		case 20: return [
			3,
			8,
			1,
			7,
			4,
			2
		];
		case 33:
		case 30:
		case 6:
		case 7:
		case 23: return [
			3,
			8,
			1,
			7,
			4
		];
		case 32:
		case 5:
		case 42:
		case 22: return [
			3,
			8,
			1,
			7,
			4,
			5
		];
		case 34:
		case 8:
		case 24: return [
			6,
			3,
			8,
			1,
			7,
			4
		];
	}
}
function stringFromEnum(fulfillmentMethod) {
	switch (fulfillmentMethod) {
		case 32: return "catering-curbside";
		case 34: return "catering-delivery";
		case 31: return "catering-dine-in";
		case 33: return "catering-outpost";
		case 30: return "catering-to-go";
		case 50: return "drive-thru-to-go";
		case 5: return "flash-curbside";
		case 8: return "flash-delivery";
		case 4: return "flash-dine-in";
		case 6: return "flash-outpost";
		case 3: return "flash-to-go";
		case 2: return "kiosk-dine-in";
		case 7: return "kiosk-outpost";
		case 1: return "kiosk-to-go";
		case 42: return "linebuster-curbside";
		case 41: return "linebuster-dine-in";
		case 40: return "linebuster-to-go";
		case 22: return "web-curbside";
		case 24: return "web-delivery";
		case 21: return "web-dine-in";
		case 23: return "web-outpost";
		case 20: return "web-to-go";
	}
}
function enumFromString(fulfillmentMethodString) {
	switch (fulfillmentMethodString) {
		case "catering-curbside": return 32;
		case "catering-delivery": return 34;
		case "catering-dine-in": return 31;
		case "catering-outpost": return 33;
		case "catering-to-go": return 30;
		case "drive-thru-to-go": return 50;
		case "flash-curbside": return 5;
		case "flash-delivery": return 8;
		case "flash-dine-in": return 4;
		case "flash-outpost": return 6;
		case "flash-to-go": return 3;
		case "kiosk-dine-in": return 2;
		case "kiosk-outpost": return 7;
		case "kiosk-to-go": return 1;
		case "linebuster-curbside": return 42;
		case "linebuster-dine-in": return 41;
		case "linebuster-to-go": return 40;
		case "web-curbside": return 22;
		case "web-delivery": return 24;
		case "web-dine-in": return 21;
		case "web-outpost": return 23;
		case "web-to-go": return 20;
	}
}
function getOutpostFulfillmentMethods() {
	return allEnumValues(OrderChannel).map(getOutpost).filter((x) => x !== null);
}
//#endregion
export { customerIdentifiers, enumFromString, fulfillment_method_helper_exports, getCurbside, getDelivery, getDineIn, getOutpost, getOutpostFulfillmentMethods, getToGo, isAnOutpost, isCurbside, isDelivery, isDineIn, isKiosk, isToGo, name, nameWithChannel, orderChannel, stringFromEnum };

//# sourceMappingURL=fulfillment_method_helper.js.map